import { Modal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../enums/modalId'
import { useScoutConnectionImapForm } from '../contexts/scoutConnectionImapFormContext'
import { ModalBody } from './ModalBody'
import { ModalFooter } from './ModalFooter'

export const ScoutConnectionImapModalComponent = (): ReactElement => {
  const { t } = useTranslation()
  const { isProcessing } = useScoutConnectionImapForm()

  return (
    <Modal id={ModalId.ScoutConnectionImapModal} size="s" closable={!isProcessing}>
      <Modal.Header title={t('scout.connection.imap.modal.header')} />
      <Modal.Body>
        <ModalBody />
      </Modal.Body>
      <Modal.Footer>
        <ModalFooter />
      </Modal.Footer>
    </Modal>
  )
}
